export function calculateTransformValue(transform, index, data, scale) {
  let item = transform.elements[index];
  if (typeof item === 'string') {
    if (item.indexOf('center') !== -1) {
      let offset = parseFloat(item.substr(6, item.length), 10) || 0;
      let center = scale * 0.5 - data * 0.5;
      console.log(offset, center, item.substr(6, item.length));
      return center + offset;
    } else {
      return scale * parseInt(item, 10);
    }
  } else {
    return item;
  }
}

export function calculateTransform(transform, width, height, node, DataObject) {
  const widthProps = [0, 1, 2, 3, 4, 12]; // height and depth props will use height
  return transform.map((item, i) => {
    const isWidth = ~widthProps.indexOf(i);
    const scale = isWidth ? width : height;
    if (typeof item === 'string') {
      if (~item.indexOf('center')) {
        const baseLayer =
          DataObject.findTypeWithin(node, 'background_layer') ||
          DataObject.findTypeWithin(node, 'envelope');
        let layerScale = node.width;
        if (baseLayer) {
          layerScale = width;
        }
        let offset = scale * parseFloat(item.substr(6, item.length), 10) || 0;
        let center = scale * 0.5 - layerScale * 0.5;
        return center + offset;
      } else {
        return scale * parseFloat(item, 10);
      }
    }
    return item;
  });
}

export function distance(p1x, p1y, p2x, p2y) {
  return Math.sqrt(Math.pow(p2x - p1x, 2) + Math.pow(p2y - p1y, 2));
}

export function isParallelogram(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
  return distance(p2x, p2y, p3x, p3y) === distance(p4x, p4y, p1x, p1y);
}
